import React from 'react'

export default function BlockIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#F87171" fill-opacity="0.1"/>
            <g clip-path="url(#clip0_3795_1117)">
                <path d="M7.26628 7.26658L16.7329 16.7332M18.6663 11.9999C18.6663 15.6818 15.6816 18.6666 11.9997 18.6666C8.31778 18.6666 5.33301 15.6818 5.33301 11.9999C5.33301 8.31802 8.31778 5.33325 11.9997 5.33325C15.6816 5.33325 18.6663 8.31802 18.6663 11.9999Z" stroke="#F87171" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_3795_1117">
                    <rect width="16" height="16" fill="white" transform="translate(4 4)"/>
                </clipPath>
            </defs>
        </svg>

    )
}